var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _vm._l(_vm.tabMapOptions, function (item, index) {
            return [
              _c(
                "el-tab-pane",
                {
                  key: item.id,
                  attrs: { label: item.groupName, name: item.id },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _vm._v(" " + _vm._s(item.groupName) + " "),
                      _c("span", [_vm._v("(" + _vm._s(item.count || 0) + ")")]),
                      _c(
                        "el-dropdown",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.type == "project" ? index > 4 : index > 5,
                              expression: "type=='project'?index>4:index>5",
                            },
                          ],
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont icon-edit edit-icon",
                          }),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.renameChange(item)
                                    },
                                  },
                                },
                                [_vm._v("重命名")]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.delChange(item)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        [
          _c("Dialogs", {
            attrs: { dialogs: _vm.dialog, width: "50%" },
            on: { dialogVisible: _vm.beforeClose },
            scopedSlots: _vm._u([
              {
                key: "desc",
                fn: function () {
                  return [
                    _c("div", { staticClass: "subbox" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "394px",
                            "margin-left": "40px",
                          },
                        },
                        [_vm._v("该分组删除之后将无法恢复，确认删除？")]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("Dialogs", {
            attrs: { dialogs: _vm.dialog1 },
            on: { dialogVisible: _vm.beforeClose },
            scopedSlots: _vm._u([
              {
                key: "desc",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "subbox" },
                      [
                        _c("div", { staticStyle: { width: "100px" } }),
                        _c("el-input", {
                          attrs: { placeholder: "请输入新的分组名称" },
                          model: {
                            value: _vm.dialog1.groupName,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialog1, "groupName", $$v)
                            },
                            expression: "dialog1.groupName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }